'use client';

import dynamic from 'next/dynamic';

export const AudienceSpotlightBlockClient = dynamic(() =>
  import('./client').then((module) => module.AudienceSpotlightBlockClient)
);
